import React from 'react';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  console.log('totalPages', totalPages);
  if (totalPages <= 1) return null;

  const generatePageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 7;
    
    if (totalPages <= maxVisiblePages) {
      // Show all pages if total is small
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Always show first page
    pages.push(1);

    if (currentPage <= 4) {
      // Near beginning: 1 2 3 4 5 ... last
      for (let i = 2; i <= 5; i++) {
        pages.push(i);
      }
      pages.push('ellipsis');
      pages.push(totalPages);
    } else if (currentPage >= totalPages - 3) {
      // Near end: 1 ... (last-4) (last-3) (last-2) (last-1) last
      pages.push('ellipsis');
      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Middle: 1 ... (current-1) current (current+1) ... last
      pages.push('ellipsis');
      pages.push(currentPage - 1);
      pages.push(currentPage);
      pages.push(currentPage + 1);
      pages.push('ellipsis');
      pages.push(totalPages);
    }

    return pages;
  };

  const pageNumbers = generatePageNumbers();

  return (
    <div className="pagination" style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: '8px',
      justifyContent: 'center',
      padding: '20px 0'
    }}>
      {/* First Button */}
      {/* <button
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
        style={{
          padding: '8px 12px',
          backgroundColor: 'white',
          color: currentPage === 1 ? '#ccc' : '#333',
          border: '1px solid #ddd',
          borderRadius: '4px',
          cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
          fontSize: '14px'
        }}
      >
        First
      </button> */}

      {/* Previous Button */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        style={{
          padding: '8px 12px',
          backgroundColor: 'white',
          color: currentPage === 1 ? '#ccc' : '#333',
          border: '1px solid #ddd',
          borderRadius: '4px',
          cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
        }}
      >
        <IoIosArrowBack />
      </button>

      {/* Page Numbers */}
      {pageNumbers.map((page, index) => {
        if (page === 'ellipsis') {
          return (
            <span 
              key={`ellipsis-${index}`}
              style={{ 
                padding: '8px 4px',
                color: '#666',
                fontSize: '16px'
              }}
            >
              ...
            </span>
          );
        }

        const isActive = page === currentPage;
        return (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            style={{
              padding: '8px 12px',
              backgroundColor: isActive ? '#333' : 'white',
              color: isActive ? 'white' : '#333',
              border: `1px solid ${isActive ? '#333' : '#ddd'}`,
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: isActive ? 'bold' : 'normal',
              minWidth: '40px'
            }}
          >
            {page}
          </button>
        );
      })}

      {/* Next Button */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        style={{
          padding: '8px 12px',
          backgroundColor: 'white',
          color: currentPage === totalPages ? '#ccc' : '#333',
          border: '1px solid #ddd',
          borderRadius: '4px',
          cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
        }}
      >
        <IoIosArrowForward />
      </button>

      {/* Last Button */}
      {/* <button
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
        style={{
          padding: '8px 12px',
          backgroundColor: 'white',
          color: currentPage === totalPages ? '#ccc' : '#333',
          border: '1px solid #ddd',
          borderRadius: '4px',
          cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
          fontSize: '14px'
        }}
      >
        Last
      </button> */}

      {/* Page Info */}
      <span style={{
        marginLeft: '16px',
        fontSize: '14px',
        color: '#666'
      }}>
        Page {currentPage} of {totalPages}
      </span>
    </div>
  );
};

export default Pagination;
